import { MobileSchema } from 'constants/ValidationSchema';
import { useFormik } from 'formik';
import { deleteInviteToken } from 'helper/inviteTokenHelper';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import toast from 'react-hot-toast';
import OtpInput from 'react-code-input';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import FormInput from '../../components/FormInput';
import AuthLayout from '../../components/Layout/AuthLayout';
import { navLinks } from '../../constants/paths';
import { onLogin } from '../../redux/authSlice';
import { useMobileMutation } from '../../redux/services/auth';
import './Mobile.scss';
import { useTranslation } from 'react-i18next';
import { RootStates } from 'redux/store';

const COUNTER = 30;

const Mobile = () => {
  const { t } = useTranslation();
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [mobile, { isLoading }] = useMobileMutation();
  const [sessionId, setSessionId] = useState('');
  const [counter, setCounter] = useState(COUNTER);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inviteSource = useSelector((state: RootStates) => state.auth.source);
  const sourceEmail = useSelector(
    (state: RootStates) => state.auth.sourceEmail,
  );

  const sendOtp = async () => {
    const res: any = await mobile({
      body: {
        ...formik.values,
        type: 'GENERATE',
        sessionId: sessionId,
      },
    });
    setShowOtpInput(true);
    setCounter(COUNTER);

    if (res.data) {
      toast.success('OTP sent');
      setSessionId(res.data.sessionId);
    }
  };

  const formik = useFormik({
    initialValues: {
      mobileNumber: '',
      sessionId: '',
      otp: '',
    },
    validationSchema: MobileSchema,
    onSubmit: async (values) => {
      const inviteToken = localStorage.getItem('inviteToken');
      const res: any = await mobile({
        body: {
          ...values,
          type: values.otp ? 'VERIFY' : 'GENERATE',
          sessionId: sessionId,
        },
        inviteToken: values.otp ? inviteToken : undefined,
        source: inviteSource,
        email: sourceEmail,
      });
      setShowOtpInput(true);
      setCounter(COUNTER);
      if (res.data && !values.otp) {
        toast.success('OTP sent');
        setSessionId(res.data.sessionId);
      } else if (res.data && values.otp) {
        localStorage.setItem('c360labs/user-details', JSON.stringify(res.data));
        dispatch(onLogin());
        if (res.data.inviteMessage) {
          toast.success(res.data.inviteMessage);
          toast[res.data.inviteSuccess ? 'success' : 'error'](
            res.data.inviteMessage,
          );
          deleteInviteToken();
        }
        navigate('/onboarding');
      } else {
        toast.error(res.error.data.message);
      }
    },
  });

  const handleResendOtp = () => sendOtp();

  useEffect(() => {
    if (showOtpInput) {
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }
  }, [counter, showOtpInput]);

  const { errors, touched } = formik;
  return (
    <AuthLayout>
      <div className="lgBox mobile">
        <h2>{t('mobile')}</h2>
        <p className="text-center tag-line invisible">{t('login_branding')}</p>
        <form onSubmit={formik.handleSubmit} noValidate className="mb-3">
          <FormInput
            label="Mobile Number"
            type="number"
            name="mobileNumber"
            value={formik.values.mobileNumber}
            onChange={formik.handleChange}
            touched={touched.mobileNumber}
            error={errors.mobileNumber}
          />
          {showOtpInput ? (
            <>
              <OtpInput
                name="otp"
                value={formik.values.otp}
                onChange={(otp: string) => formik.setFieldValue('otp', otp)}
                fields={6}
                className="mb-3 form-control w-100 otp-input"
                type="number"
                inputMode="numeric"
              />
              <div className="text-end mb-3">
                <Button
                  variant="link"
                  className="p-0"
                  disabled={counter === 0 ? false : true}
                  onClick={handleResendOtp}
                >
                  {t('resend_otp')}
                </Button>
                <span className="mx-2">
                  {counter > 0 ? (
                    <>00:{counter < 10 ? `0${counter}` : counter}</>
                  ) : (
                    ''
                  )}
                </span>
              </div>
            </>
          ) : null}
          <Button
            type="submit"
            variant="primary"
            className="w-100"
            disabled={isLoading}
          >
            {t('submit')}
          </Button>
        </form>
        <div className="form-group text-center">
          {t('already_have_account')}
          <Link to={navLinks.login} className="text-decoration-none">
            {t('login')}
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Mobile;
